// extracted by mini-css-extract-plugin
export default {"label":"label__VepInputSummary__1T+jQ","smallLight":"smallLight__VepInputSummary__1T+jQ"};